export default class PreviewRequestEntry {
  constructor() {
      this.bid = 0;
      this.fuid = 0;
      this.frn = 0;
      this.rrn = 0;
      this.fqPath = null;
      this.previewConstraints = null;
  }
}